import { connect } from 'react-redux';
import { createArticleLink } from '../../../utils/linkCreator';
import ViewOnlyPopover from './viewOnlyPopover';

const mapStateToProps = ({ pdfContent: { identification = {} } }) => ({
  articleLink: createArticleLink(identification),
});

export default connect(mapStateToProps)(ViewOnlyPopover);
